import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    // Old routes
    {
      path: '/',
      component: () => import('@/views/freelancer/my-tasks.vue'),
    },
    {
      path: '/content',
      component: () => import('@/views/freelancer/overview.vue'),
    },
    {
      path: '/content/new/:type',
      component: () => import('@/views/freelancer/content/new.vue'),
    },
    {
      path: '/content/:id',
      name: 'contentId',
      component: () => import('@/views/freelancer/content/id.vue'),
    },
    {
      path: '/linkbuilding/new',
      component: () => import('@/views/freelancer/linkbuilding/new.vue'),
    },
    {
      path: '/linkbuilding/:id',
      name: 'linkbuildingId',
      component: () => import('@/views/freelancer/linkbuilding/id.vue'),
    },
    {
      path: '/chatterbox/new',
      component: () => import('@/views/freelancer/chatterbox/new.vue'),
    },
    {
      path: '/chatterbox/:id',
      name: 'chatterboxId',
      component: () => import('@/views/freelancer/chatterbox/id.vue'),
    },
    {
      path: '/approvals/linkbuilding',
      component: () => import('@/views/admin/linkbuilding/overview.vue'),
    },
    {
      path: '/approvals/linkbuilding/:id',
      component: () => import('@/views/admin/linkbuilding/id.vue'),
    },
    {
      path: '/approvals/chatterbox',
      component: () => import('@/views/admin/chatterbox/overview.vue'),
    },
    {
      path: '/approvals/chatterbox/:id',
      component: () => import('@/views/admin/chatterbox/id.vue'),
    },
    {
      path: '/approvals/:type',
      component: () => import('@/views/admin/content/overview.vue'),
    },
    {
      path: '/approvals/:type/:id',
      component: () => import('@/views/admin/content/id.vue'),
    },
    // Routes to keep
    {
      path: '/profile',
      component: () => import('@/views/profile.vue'),
    },
    {
      path: '/freelancers',
      component: () => import('@/views/admin/freelancers.vue'),
    },
    {
      path: '/chatterbox-overview',
      component: () => import('@/views/admin/chatterbox-overview.vue'),
    },
    // New Routes
    {
      path: '/tasks',
      component: () => import('@/views/freelancer/tasks.vue'),
    },
    {
      path: '/overview/:type',
      component: () => import('@/views/admin/overview.vue'),
    },
    {
      path: '/task/new',
      name: 'new',
      component: () => import('@/views/admin/task/new.vue'),
      props: true,
    },
    {
      path: '/task/:id',
      name: 'taskId',
      component: () => import('@/views/taskid.vue'),
    },
  ],
})
